import React from 'react';
import ReactDOM from 'react-dom';

const ACCESSIBILITY_ENVIRONMENTS = new Set(['local', 'staging']);

const isAccessibilityEnabledEnvironment = (): boolean => {
  if (typeof window === 'undefined' || !window.CUROLOGY_ENV?.APP_ENV) {
    return false;
  }

  return ACCESSIBILITY_ENVIRONMENTS.has(window.CUROLOGY_ENV.APP_ENV);
};

export const applyAccessibilityChecks = async (renderApp: () => void) => {
  // Builds for staging run with NODE_ENV=production; rely on the runtime APP_ENV check above so
  // accessibility tooling stays enabled there while staying disabled in true production.
  if (isAccessibilityEnabledEnvironment()) {
    const { default: reactAxe } = await import('@axe-core/react');
    const { axeConfig, axeContext, DEBOUNCE_TIMEOUT } = await import(
      './config'
    );

    reactAxe(React, ReactDOM, DEBOUNCE_TIMEOUT, axeConfig, axeContext);
  }

  renderApp();
};
